const locale = {
  ui: {
    titleEyebrow: 'Un jeu de cartes',
    titleSub:
      'Vos 90 premiers jours en tant que Product Manager dans une SaaS de taille moyenne. ' +
      'Survivez à 60 cartes. Ne faites pas trop le malin, ne tombez pas au trente sixième dessous.',
    titleCta: 'Démarrer le jour 1',
    titleBest: 'Meilleur run',
    titleEndings: 'Fins débloquées',
    titleDays: 'jours',
    creditsBy: 'thenew.pm — un jeu de prise de décision web par',
    creditsTagline: 'un jeu où vous êtes le nouveau product manager',
    playHint: 'Glissez, tapez ou utilisez ← / →',
    dayLabel: 'Jour',
    endingDayLost: 'Jour {day} — partie terminée',
    endingDayWon: 'Jour 90 — vous avez survécu',
    endingRestart: 'Nouveau PM, nouveau départ',
    endingUnlocked: '{n} fins débloquées sur {total}',
  },
  stats: {
    e: { short: 'Ingé',   label: 'Confiance ingénierie' },
    x: { short: 'Exec',   label: 'Confiance exec' },
    u: { short: 'Impact', label: 'Impact utilisateur' },
    p: { short: 'Énergie', label: 'Énergie personnelle' },
  },
  roles: {
    engineer:  'Ingénieur',
    designer:  'Design',
    exec:      'Exécutif',
    customer:  'Client',
    sales:     'Sales',
    data:      'Data',
    intern:    'Stagiaire',
    recruiter: 'Recruteur',
  },
  endings: {
    e0:   { title: 'Ignoré en silence',
            line: "L'ingénierie a arrêté de lire tes messages Slack au jour 47." },
    e100: { title: "Capturé par l'ingénierie",
            line: 'Tu es PM de nom seulement. Les tech leads décident maintenant ce qui livre.' },
    x0:   { title: 'Viré',
            line: "Le CEO avait besoin d'un bouc émissaire pour le trimestre raté. Tu étais le plus récent." },
    x100: { title: "Pantin de l'exec",
            line: "Tu livres la slide OKR chaque vendredi. Rien d'autre n'a livré depuis des semaines." },
    u0:   { title: 'Ça a flopé',
            line: "Le lancement est sorti. Personne n'a remarqué." },
    u100: { title: 'Spirale du scope',
            line: "Toutes les features du mur ont été construites. Aucune n'a été utilisée." },
    p0:   { title: 'Burn-out',
            line: 'Arrêt maladie au jour 73. Ton laptop est encore sur le bureau.' },
    p100: { title: 'Spirale maniaque',
            line: "Doc de stratégie de 47 pages. Mardi 3h du matin. Personne ne l'avait demandée." },
    w_cpo:       { title: 'CPO malgré toi',
                   line: "Le board te veut au coin du couloir. Tu n'es pas sûr de le vouloir." },
    w_shipped:   { title: 'Le PM qui a livré',
                   line: "Tu as livré le truc. Les gens l'utilisent. L'équipe est encore là." },
    w_hero:      { title: 'Héros interne, mystère externe',
                   line: "L'ingé t'adore. Marketing n'a jamais entendu parler de toi." },
    w_whisperer: { title: 'Murmureur de roadmap',
                   line: "Rien n'était parfait. Rien ne brûlait. L'équipe te fait confiance." },
    w_survivor:  { title: 'Tu as survécu 90 jours',
                   line: "Tu es encore là. C'est l'essentiel." },
  },
  cards: {
    c001: { title: 'Ingénieure Staff',
            prompt: "La migration auth va prendre deux semaines de retard. On le dit à l'équipe exec maintenant ou on attend la démo de vendredi ?",
            left: 'Attendre la démo', right: 'Le signaler aujourd\'hui' },
    c002: { title: 'Designer Senior',
            prompt: "L'équipe ingé a livré le nouveau dashboard sans mon empty state redesigné. Encore.",
            left: 'Pousser un hotfix', right: 'Le mettre en v2' },
    c003: { title: 'VP Produit',
            prompt: 'Le board veut une slide "stratégie IA" pour jeudi. On n\'a pas de stratégie IA.',
            left: 'En esquisser une ce week-end', right: "Lui dire que c'est prématuré" },
    c004: { title: 'PM chez TrialCo',
            prompt: '"Votre onboarding m\'a fait pleurer. Et pas de joie. On est partis chez votre concurrent."',
            left: 'Programmer un appel', right: 'Transférer au support' },
    c005: { title: 'AE Enterprise',
            prompt: "Un prospect stratégique veut SSO + audit logs + SLA custom. 500k€ d'ARR en jeu.",
            left: 'Décliner poliment', right: 'Le construire' },
    c006: { title: 'Data Scientist',
            prompt: "L'A/B test est non concluant mais on a dépassé la deadline. On ship la variante ou on l'enterre ?",
            left: 'Livrer la variante', right: "L'enterrer, relancer" },
    c007: { title: 'Stagiaire Produit',
            prompt: '"J\'ai une idée de feature. C\'est en gros Slack mais pour les chats."',
            left: 'Lui dire de se concentrer', right: "L'écouter" },
    c008: { title: 'Recruteuse Tech',
            prompt: "Le candidat PM senior vient d'avoir une contre-offre de Stripe. On a 24 heures.",
            left: "Matcher l'offre", right: 'Le laisser partir' },
    c009: { title: 'Engineering Manager',
            prompt: "La moitié de mon équipe pense que la roadmap c'est de la perf. L'autre moitié pense que c'est le redesign.",
            left: 'Clarifier dans un doc', right: "Leur dire de demander à l'EM" },
    c010: { title: 'Product Designer',
            prompt: "Marketing m'a poussé un Figma avec leur idée pour la page pricing. Ça utilise Comic Sans.",
            left: 'Le refaire poliment', right: "Transférer à l'équipe brand" },
    c011: { title: 'CEO',
            prompt: '"Pourquoi sommes-nous encore sur des OKRs trimestriels ? Anthropic livre toutes les six semaines."',
            left: 'Tester des cycles de 6 semaines', right: 'Défendre le trimestre' },
    c012: { title: 'Procurement',
            prompt: "Ils veulent un rapport SOC 2 Type II avant fin de mois sinon ils ne renouvellent pas.",
            left: 'Promettre la date', right: 'Repousser au trimestre prochain' },
    c013: { title: 'Account Executive',
            prompt: 'Le prospect en démo demande si on a une intégration HubSpot. On n\'en a pas. Je peux leur dire "sur la roadmap" ?',
            left: 'Oui, promesse vague', right: 'Non, dis-leur non' },
    c014: { title: 'Senior Data Scientist',
            prompt: "Je pense que le funnel d'activation compte en double les essais du même domaine email.",
            left: 'Mettre la métrique en pause', right: 'Corriger discrètement plus tard' },
    c015: { title: 'Stagiaire Produit',
            prompt: '"Je peux venir au séminaire leadership ? Je prendrais juste des notes."',
            left: 'L\'emmener', right: 'Peut-être la prochaine fois' },
    c016: { title: 'Ingénieur Senior',
            prompt: "Il y a six mois de dette design sur la page settings. Tu veux que je le corrige pendant mes 20% ?",
            left: "Oui s'il te plaît", right: 'Reste sur la roadmap' },
    c017: { title: 'UX Researcher',
            prompt: "J'ai cinq entretiens utilisateurs prévus. Tu veux te joindre à moi pour voir ?",
            left: "Bloquer 2h, y aller", right: 'Envoie juste les notes' },
    c018: { title: 'CRO',
            prompt: "Sales dit qu'on signerait 30% de plus avec une offre gratuite. Marketing dit que ça tuerait la conversion.",
            left: 'Lancer un pilote offre gratuite', right: 'Tenir la ligne' },
    c019: { title: 'Power User, ScaleCo',
            prompt: '"Votre export CSV tronque à 10k lignes et on en a besoin de 100k. Ça bloque notre trimestre."',
            left: 'Livrer une limite plus haute', right: "Suggérer l'API" },
    c020: { title: 'AE Enterprise',
            prompt: 'Leur CTO veut un call de 30 min avec "le PM qui pilote vraiment la roadmap". C\'est toi.',
            left: 'Prendre le call', right: 'Envoyer un deck à la place' },
    c021: { title: 'Frontend Lead',
            prompt: "On migre le design system en v3 avant ou après le lancement du redesign ?",
            left: 'Avant (le faire bien)', right: "Après (livrer d'abord)" },
    c022: { title: 'Data Scientist',
            prompt: "Mixpanel dit que la rétention monte de 4%. Amplitude dit qu'elle est flat. Les deux ont été câblés par des stagiaires.",
            left: 'Auditer les deux', right: 'Citer Mixpanel quand même' },
    c023: { title: 'VP Produit',
            prompt: 'Tu peux me pondre un one-pager sur "product-led growth" pour vendredi ? Juste trois slides.',
            left: 'En faire un vrai', right: 'Recycler le post de Lenny' },
    c024: { title: 'Stagiaire Produit',
            prompt: "J'ai remarqué que l'email d'activation part 14 minutes après l'inscription. Ça devrait être instantané ?",
            left: "Le faire corriger aujourd'hui", right: 'Ouvrir un ticket' },
    c025: { title: 'Recruteuse Tech',
            prompt: "On a headcount pour un PM de plus. Senior généraliste ou junior orienté growth ?",
            left: 'Senior généraliste', right: 'Junior orienté growth' },
    c026: { title: 'Designer Senior',
            prompt: "On A/B teste la nouvelle page pricing ou on la ship direct ?",
            left: 'La A/B tester', right: 'La livrer direct' },
    c027: { title: 'Ingénieure Staff',
            prompt: "On a un bug P1 en prod. L'ingé d'astreinte est au mariage de sa sœur.",
            left: "Pager quelqu'un d'autre", right: 'Attendre demain' },
    c028: { title: 'Équipe Sécurité',
            prompt: '"Votre stratégie de résidence des données est floue. On a besoin de EU-only au Q3 ou on ne peut pas s\'étendre."',
            left: "S'engager pour le Q3", right: 'Le repousser au Q4' },
    c029: { title: 'Account Executive',
            prompt: "J'ai dit à un prospect qu'on allait construire un sync Salesforce. T'inquiète, c'est petit.",
            left: "L'ajouter à la roadmap", right: 'Lui faire rétracter' },
    c030: { title: 'Senior Data Scientist',
            prompt: 'La North Star metric c\'est "weekly active teams". La moitié de l\'entreprise track "daily active users".',
            left: "Forcer l'alignement", right: 'Laisser dériver' },
    c031: { title: 'CFO',
            prompt: "La facture cloud a augmenté de 38% le mois dernier. C'était toi ?",
            left: 'Enquêter', right: 'Blâmer le vendor' },
    c032: { title: 'Product Designer',
            prompt: "Je veux faire un design sprint en offsite. Trois jours, zéro meeting. Approuvé ?",
            left: 'Approuvé', right: 'Peut-être au trimestre prochain' },
    c033: { title: 'Engineering Manager',
            prompt: "Mon équipe veut réécrire le service de billing en Rust. Ils prototypent déjà.",
            left: 'Arrêter le proto', right: 'Time-boxer une semaine' },
    c034: { title: 'Power User, ScaleCo',
            prompt: '"Vous aviez promis le dark mode au QBR. Ça fait six mois."',
            left: 'Livrer le dark mode maintenant', right: "S'excuser, repousser" },
    c035: { title: 'AE Enterprise',
            prompt: "Je peux partager la roadmap Notion avec le prospect ? Ils n'arrêtent pas de demander.",
            left: 'Envoyer un PDF nettoyé', right: 'Envoyer le lien live' },
    c036: { title: 'Data Scientist',
            prompt: "J'ai construit un modèle de churn. Il dit que notre plus gros client part dans 47 jours.",
            left: 'Le dire à leur CSM', right: 'Attendre plus de signal' },
    c037: { title: 'Stagiaire Produit',
            prompt: '"Mon stage se termine dans deux semaines. Une chance d\'avoir un retour offre ?"',
            left: 'Oui, je me bats pour', right: 'Être honnête : pas sûr' },
    c038: { title: 'Recruteuse Tech',
            prompt: "Le candidat nous a ghosté après le test à la maison. On peut le sauter pour les seniors ?",
            left: 'Sauter pour les seniors', right: 'Garder le niveau' },
    c039: { title: 'CEO',
            prompt: "Je veux une démo à l'All Hands vendredi. Choisis un truc cool.",
            left: 'Démos la feature IA à moitié faite', right: 'Démos le fix billing ennuyeux' },
    c040: { title: 'Ingénieur Senior',
            prompt: "Notre staging marche plus depuis trois semaines. Personne ne s'en occupe.",
            left: "M'en occuper", right: "C'est un problème SRE" },
    c041: { title: 'Designer Senior',
            prompt: "Brand veut rafraîchir notre logo. Ils ont un moodboard avec sept serifs dessus.",
            left: 'Laisser brand décider', right: "Leur demander d'attendre" },
    c042: { title: 'Admin',
            prompt: '"Votre dernière release a silencieusement cassé notre SAML. On est repassés sur email/mot de passe."',
            left: 'Rollback ce soir', right: 'Patcher demain matin' },
    c043: { title: 'Account Executive',
            prompt: 'Le CTO du prospect veut voir notre Jira board. "Pour la confiance".',
            left: 'Partager une vue nettoyée', right: "Non, c'est bizarre" },
    c044: { title: 'Senior Data Scientist',
            prompt: "Looker Studio est down. Deux execs me pingent. Je peux juste leur envoyer le CSV d'hier ?",
            left: 'Envoyer le CSV', right: 'Les faire attendre' },
    c045: { title: 'VP Produit',
            prompt: "Je te programme pour une prés' au séminaire leadership. 20 minutes, sans slides.",
            left: 'Prendre le créneau', right: 'Décliner poliment' },
    c046: { title: 'Frontend Lead',
            prompt: "On adopte React 19 maintenant ou on attend six mois que les choses se calment ?",
            left: 'Adopter maintenant', right: 'Attendre six mois' },
    c047: { title: 'Stagiaire Produit',
            prompt: '"J\'ai shadow trois calls sales et fait un doc sur les top objections. On peut livrer un fix ?"',
            left: "L'amener au standup", right: 'Garder pour le trimestre prochain' },
    c048: { title: 'Recruteuse Tech',
            prompt: 'Le candidat a dit qu\'il veut "travailler sur quelque chose qui compte". J\'envoie le deck des valeurs ?',
            left: 'Envoyer le deck', right: 'Être juste honnête' },
    c049: { title: 'Power User',
            prompt: '"Je paierais le double si vous me laissiez auto-héberger. Je fais confiance à personne avec mes données, sans vouloir vexer."',
            left: 'Explorer une offre auto-hébergée', right: 'Décliner poliment' },
    c050: { title: 'CRO',
            prompt: "On peut avancer l'augmentation de rate-limit API de deux semaines ? Ça débloquerait trois deals.",
            left: 'Je vais voir ce que je peux faire', right: "Non, l'équipe est à capacité" },
    c051: { title: 'Product Designer',
            prompt: "J'ai designé trois options pour la nouvelle navigation. Une ambitieuse, une safe, une pour les ingés.",
            left: 'Ambitieuse? J\'aime ça!', right: 'Livrer la safe' },
    c052: { title: 'Ingénieure Staff',
            prompt: "La dette technique que j'avais signalée semaine 1 bloque maintenant le lancement. Postmortem ?",
            left: 'Oui, postmortem complet', right: 'Non, on continue' },
    c053: { title: 'Data Scientist',
            prompt: "Notre graph DAU a un pic bizarre le dimanche. Je pense que c'est du trafic bot depuis le docs site.",
            left: "L'enlever de la métrique", right: "Laisser, c'est joli" },
    c054: { title: 'CEO',
            prompt: "Stripe vient de livrer ce qu'on construit depuis trois trimestres. Je les appelle ?",
            left: 'Parler à Patrick', right: "Non, on a un angle" },
    c055: { title: 'Admin',
            prompt: '"On est sur le trial depuis 90 jours. On a besoin d\'une extension de 90 jours."',
            left: "L'accorder", right: "Les faire s'engager" },
    c056: { title: 'AE Enterprise',
            prompt: "Procurement veut un volume discount de 60%. Le CRO dit oui. Le modèle dit non.",
            left: 'Tenir la ligne', right: 'Accepter le discount' },
    c057: { title: 'Engineering Manager',
            prompt: "Deux de mes meilleurs ingés veulent passer dans l'équipe plateforme. On perdrait de la vélocité sur la roadmap.",
            left: 'Les laisser partir', right: 'Bloquer le transfert' },
    c058: { title: 'UX Researcher',
            prompt: "Huit users sur dix se sont bloqués sur la page settings en test d'utilisabilité. Tu veux les clips ?",
            left: 'Envoyer au leadership', right: 'Juste corriger discrètement' },
    c059: { title: 'Stagiaire Produit',
            prompt: '"J\'ai remarqué que le lien de désabonnement est cassé. Je vais le réparer avant de partir."',
            left: 'Approuver le fix', right: 'Faire faire ça par un FTE' },
    c060: { title: 'VP Produit',
            prompt: "Il me faut un 30-60-90 de ta part pour le board. Demain.",
            left: 'Tirer une nuit blanche', right: 'Envoyer celui du trimestre dernier' },
    c061: { title: 'Ingénieur Senior',
            prompt: "Je fais mon deck rétro perso ou j'utilise le template équipe ?",
            left: 'Utiliser le template', right: 'Fais le tien' },
    c062: { title: 'Designer Senior',
            prompt: 'On appelle notre design system "Atlas" mais legal dit que la marque appartient à quelqu\'un d\'autre.',
            left: 'Le renommer', right: 'Prendre le risque' },
    c063: { title: 'Senior Data Scientist',
            prompt: "Marketing m'a demandé de faire un A/B test sur une feature déjà 100% déployée.",
            left: 'Leur dire non', right: 'Bidouiller avec un holdout' },
    c064: { title: 'Power User, ScaleCo',
            prompt: '"Votre concurrent propose de nous migrer gratuitement. Convaincs-moi de rester."',
            left: 'Avoir un call', right: 'Envoyer le deck' },
    c065: { title: 'Account Executive',
            prompt: 'Tu peux assister au QBR ? Le client a spécifiquement demandé "quelqu\'un de technique".',
            left: 'Oui', right: "Envoyer l'EM" },
    c066: { title: 'CFO',
            prompt: "Le cash burn de ton équipe est 12% au-dessus du plan. Qu'est-ce qu'on coupe ?",
            left: 'Couper les expérimentations IA', right: 'Couper le redesign' },
    c067: { title: 'Frontend Lead',
            prompt: "On a l'opportunité de déprécier le support IE11. 200ms gagnés sur chaque page.",
            left: 'Le déprécier', right: 'Attendre encore un an' },
    c068: { title: 'Stagiaire Produit',
            prompt: '"Dernier jour. J\'ai fait un deck de tout ce que tu devrais corriger selon moi. Tu veux le voir ?"',
            left: 'Le lire attentivement', right: 'Le survoler plus tard' },
    c069: { title: 'Recruteuse Tech',
            prompt: "Trois personnes de l'équipe ingé veulent référer leurs potes. On baisse le niveau ?",
            left: 'Garder le niveau', right: 'Fast-track les referrals' },
    c070: { title: 'CRO',
            prompt: 'Sales veut "IA" dans la copy produit sur chaque page. On peut livrer un bandeau cette semaine ?',
            left: 'Oui, on colle ça partout', right: "Non, c'est du bruit" },
    c071: { title: 'Ingénieure Staff',
            prompt: "Je pense à partir. Pas pour l'argent. La roadmap ne m'excite pas.",
            left: 'Avoir un vrai 1:1', right: 'Lui souhaiter bonne chance' },
    c072: { title: 'Product Designer',
            prompt: "Marketing veut utiliser les écrans v2 non sortis dans une vidéo de lancement. Avant le lancement.",
            left: "Non, c'est pas fini", right: 'Pourquoi pas' },
    c073: { title: 'Data Scientist',
            prompt: "J'ai refait le funnel. La vraie activation est 11%, pas 24%. On a dit 24% aux investisseurs.",
            left: 'Le dire ce soir', right: 'Garder pour soi' },
    c074: { title: 'Procurement',
            prompt: '"Le renouvellement arrive. On veut 30% de réduction sinon on part chez vendor X."',
            left: 'Matcher le discount', right: 'Les laisser partir' },
    c075: { title: 'AE Enterprise',
            prompt: 'Tu peux venir à mon dîner prospect vendredi ? Ils veulent spécifiquement "la perspective produit".',
            left: 'Aller au dîner', right: 'Envoyer un deck' },
    c076: { title: 'Engineering Manager',
            prompt: "Mon équipe a fait une rétro blameless. La moitié des items concerne tes changements de roadmap.",
            left: "Le lire, l'assumer", right: 'Pousser sur le framing' },
    c077: { title: 'CEO',
            prompt: "Je veux que tu pilotes une nouvelle motion GTM. Self-serve. Tu choisis l'équipe.",
            left: 'Prendre', right: 'Rester focus' },
    c078: { title: 'Stagiaire de retour',
            prompt: '"Je rentre de l\'école. J\'ai une offre retour Meta. Je reste là-bas ou je viens ici ?"',
            left: 'Le convaincre', right: 'Pros et cons honnêtes' },
    c079: { title: 'Recruteuse Tech',
            prompt: 'On a un PM senior parfait en ligne. Il veut full remote. On est "hybride flexible".',
            left: 'Faire une exception', right: 'Tenir la politique' },
    c080: { title: 'UX Researcher',
            prompt: "On a le budget pour une grosse initiative de recherche. Deep-dive onboarding ou interviews de churn ?",
            left: 'Onboarding', right: 'Interviews de churn' },
    c081: { title: 'Ingénieur Senior',
            prompt: "J'aimerais écrire un blog post d'ingénierie public sur notre migration. Marketing a dit non.",
            left: 'Outrepasser marketing', right: 'Prendre le parti de marketing' },
    c082: { title: 'Power User',
            prompt: '"Vous avez une alpha privée pour la feature IA. Je peux y entrer ? Je vous fais un testimonial."',
            left: 'Les ajouter', right: 'Attendre la GA' },
    c083: { title: 'VP Produit',
            prompt: "Je pars dans un mois. Tu veux mon poste ? Je te soutiendrai, même si tu n'es pas là depuis longtemps.",
            left: 'Oui', right: 'Pas encore' },
    c084: { title: 'Senior Data Scientist',
            prompt: "Je veux mettre en place une revue hebdo des métriques produit. 30 min, chaque lundi. Approuvé ?",
            left: 'Approuvé', right: 'On a déjà trop de meetings' },
    c085: { title: 'Account Executive',
            prompt: "Je peux enregistrer ta démo et l'envoyer aux leads ? On a 3x plus de réponses quand les PMs les font.",
            left: 'OK, enregistre', right: 'Je ne suis pas Marketing' },
    c086: { title: 'Frontend Lead',
            prompt: "On doit déprécier l'ancienne API. Deux clients sont dessus. Les deux sont minuscules. Les deux vont crier.",
            left: 'Déprécier comme prévu', right: 'Repousser de six mois' },
    c087: { title: 'Designer Senior',
            prompt: "Je veux arrêter de designer dans Figma et essayer Penpot. L'équipe est divisée.",
            left: 'OK, essaie', right: 'Rester sur Figma' },
    c088: { title: 'CRO',
            prompt: "Je veux une roadmap publique. Sales adorerait. Ingé détesterait.",
            left: 'Livrer une roadmap publique', right: 'Garder en interne' },
    c089: { title: 'CISO',
            prompt: '"Vous avez eu un incident mineur le mois dernier. On veut un postmortem écrit et un crédit."',
            left: 'Envoyer les deux', right: 'Postmortem seulement' },
    c090: { title: 'Stagiaire de retour',
            prompt: '"Pour ma présentation finale : la seule chose que tu aurais aimé qu\'on te dise le premier jour ?"',
            left: 'Être honnête', right: 'Dire un truc safe' },
    c091: { title: 'Frontend Lead',
            prompt: "L'ingé veut migrer de Jira à Linear. La moitié de l'équipe a la mémoire musculaire des requêtes Jira.",
            left: 'Approuver le passage', right: 'Rester sur Jira' },
    c092: { title: 'Product Designer',
            prompt: "L'ingé veut un Storybook pour chaque composant. Trois semaines de boulot, zéro changement visible utilisateur.",
            left: 'Prendre le temps', right: "Sauter pour l'instant" },
    c093: { title: 'VP Produit',
            prompt: "Mon deck board fait 47 slides. Tu m'aides à le réduire avant jeudi ?",
            left: 'Le couper à 12', right: 'Ajouter une annexe' },
    c094: { title: 'Power User',
            prompt: '"Pourquoi votre support est sur Intercom et pas Slack ? On vit dans Slack."',
            left: 'Ajouter un channel Slack', right: 'Rester sur Intercom' },
    c095: { title: 'AE Enterprise',
            prompt: "Procurement veut une indemnité illimitée dans le contrat. Legal dit jamais. Sales dit oui.",
            left: 'Plafonner à 1M$', right: 'Accepter illimité' },
    c096: { title: 'Senior Data Scientist',
            prompt: "On a 47 dashboards. Huit personnes les utilisent. Tu veux que je déprécie les 30 du bas ?",
            left: 'Les déprécier', right: 'Les laisser tranquilles' },
    c097: { title: 'Engineering Manager',
            prompt: "Il nous faut une rotation d'astreinte 24/7. Trois ingés refusent. Deux disent qu'ils démissionneront si on les force.",
            left: 'Sur la base du volontariat', right: 'Le rendre obligatoire' },
    c098: { title: 'Designer Senior',
            prompt: "Brand veut un doc de guidelines de 60 pages. L'ingé dit que personne ne le lira.",
            left: 'Construire le doc complet', right: 'Un one-pager suffira' },
    c099: { title: 'Stagiaire de retour',
            prompt: '"Je veux un mentor hors de ma chaîne. Tu peux m\'en trouver un ?"',
            left: 'Les mettre en relation', right: 'Suggérer qu\'il se débrouille' },
    c100: { title: 'CRO',
            prompt: "Acheter le module analytics de CompetitorCo à 400k$ ou le construire en deux trimestres ?",
            left: "L'acheter", right: 'Le construire nous-mêmes' },
    c101: { title: 'Admin',
            prompt: 'Le NPS a chuté de 14 points en un mois. Les verbatims mentionnent tous "performance".',
            left: 'Pauser les features pour la perf', right: 'Pousser la perf au trimestre prochain' },
    c102: { title: 'Recruteuse Tech',
            prompt: "On a benchmark notre grille de comp PM. On est 18% en dessous du marché. RH refuse d'ajuster.",
            left: 'Escalader au CEO', right: 'Faire avec' },
    c103: { title: 'Ingénieur Senior',
            prompt: "Je veux splitter le monorepo. C'est huit mois de boulot. L'équipe est divisée.",
            left: 'Approuver le split', right: 'Garder le monorepo' },
    c104: { title: 'Account Executive',
            prompt: "Un revendeur veut nous white-label en APAC. 30% de marge pour eux, zéro coût GTM pour nous.",
            left: 'Signer le deal', right: 'Rester en direct' },
    c105: { title: 'CEO',
            prompt: "Je veux recruter un Head of AI. Le candidat vient d'OpenAI et veut 700k$ de base.",
            left: "Faire l'offre", right: 'Promouvoir en interne' },
    c106: { title: 'Data Scientist',
            prompt: "L'audit RGPD a trouvé quatre cookies posés sans consentement. Legal les veut supprimés ce soir.",
            left: 'Les supprimer ce soir', right: 'Planifier pour le sprint' },
    c107: { title: 'UX Researcher',
            prompt: "L'audit d'accessibilité a trouvé 38 échecs WCAG-AA. La plupart sont des contrastes de couleur.",
            left: 'Bloquer la release', right: 'Livrer, ouvrir des tickets backlog' },
    c108: { title: 'Power User, ScaleCo',
            prompt: '"Votre status page disait \'tous systèmes opérationnels\' pendant une panne de 90 minutes. On remarque."',
            left: 'Postmortem + excuses', right: 'Mettre à jour le SLA discrètement' },
    c109: { title: 'AE Enterprise',
            prompt: "J'ai trois RFPs pour vendredi. Chacun fait 80 pages de questions de compliance.",
            left: 'Aider sur les trois', right: 'Trier vers un seul' },
    c110: { title: 'CFO',
            prompt: "On est à 18 mois de la faillite. Tu soutiens quoi pour les leaders ? Licenciements ou couper la prochaine ligne produit ?",
            left: 'Couper la ligne produit', right: 'Petits licenciements' },
    f_custom_arr: { title: 'AE Enterprise',
            prompt: "Trois semaines plus tard. La feature custom à 500k€ a été livrée. Ils en veulent deux autres.",
            left: 'Tenir la ligne', right: 'Construire la suivante' },
    f_salesforce_sync: { title: 'Engineering Manager',
            prompt: "À propos du sync Salesforce. C'est trois sprints de boulot. On n'a pas trois sprints.",
            left: 'Couper une autre feature', right: "Dire à sales que ça n'arrivera pas" },
    f_indemnity: { title: 'AE Enterprise',
            prompt: "Trois semaines plus tard. Le client a déclenché une réclamation de 3M$ sous cette indemnité illimitée.",
            left: 'Payer, apprendre', right: 'Combattre au tribunal' },
    f_oncall: { title: 'Engineering Manager',
            prompt: "Deux semaines après. L'astreinte volontaire a eu un volontaire. Il est en burn-out rapide.",
            left: 'Payer plus, doubler la rotation', right: 'La rendre obligatoire maintenant' },
    f_brand: { title: 'Designer Senior',
            prompt: "Le doc brand de 60 pages est fini. L'ingé n'en utilise rien.",
            left: 'Imposer la conformité', right: 'Le laisser mourir discrètement' },
    f_buy_build: { title: 'CRO',
            prompt: "Le module CompetitorCo ne s'intègre pas. Leur API n'est pas documentée.",
            left: 'Exiger un remboursement', right: 'Construire un wrapper' },
    f_monorepo: { title: 'Ingénieur Senior',
            prompt: "Trois mois après. Le split est à moitié fait. La CI est cassée dans les deux repos.",
            left: 'Faire un rollback', right: 'Continuer' },
    f_channel: { title: 'Account Executive',
            prompt: "Le revendeur APAC casse les prix sur nos deals directs en ANZ. Les clients sont confus.",
            left: "Sortir l'ANZ", right: 'Couper le revendeur' },
    f_ai_hire: { title: 'CEO',
            prompt: "Le Head of AI a commencé lundi. Vendredi il veut rediriger toute la roadmap.",
            left: "L'écouter", right: 'Tenir la ligne' },
    f_a11y: { title: 'UX Researcher',
            prompt: "Les 38 fixes WCAG ont été livrés. Sales dit qu'on est maintenant éligibles pour un RFP secteur public.",
            left: 'Poursuivre le RFP', right: 'Rester focus sur SMB' },
    f_rfp: { title: 'AE Enterprise',
            prompt: "On a gagné un des trois RFPs. La livraison promise est de 6 semaines. L'ingé a ri.",
            left: 'Renégocier le scope', right: 'Promettre, puis étirer' },
    f_layoffs: { title: 'CFO',
            prompt: "La ligne produit que tu as coupée avait trois clients à 1.2M$ d'ARR. Ils veulent un remboursement.",
            left: 'Rembourser intégralement', right: 'Offrir un crédit sur le produit principal' },
    c111: { title: 'CTO',
            prompt: "Je veux tout internaliser. On laisse AWS, on laisse Stripe, on construit nous-mêmes. Plan sur trois ans.",
            left: 'Lancer une étude de faisabilité', right: 'Rester focus sur ce qu\'on a' },
    c112: { title: 'Mobile Lead',
            prompt: "Apple vient de rejeter notre app. Ils ont flagué la feature IA comme \"génération d'informations non vérifiées\".",
            left: 'Resoumettre avec disclaimers', right: 'Contester le rejet' },
    c113: { title: 'VP Produit',
            prompt: 'Je veux que la planif trimestrielle prenne cinq jours, pas deux. De vrais OKRs, pas des slides.',
            left: 'Adopter', right: 'Deux jours suffisent' },
    c114: { title: 'Power User',
            prompt: '"On veut être design partner. Produit gratuit, vous récupérez notre logo et une citation."',
            left: 'Les inscrire', right: "On n'a pas besoin de logo" },
    c115: { title: 'Ingénieur Sécurité',
            prompt: "Le pen test a trouvé trois vulns RCE dans l'API. On a 24h avant la divulgation.",
            left: 'Tout le monde sur le pont', right: 'Négocier la fenêtre de divulgation' },
    c116: { title: 'Sales Engineer',
            prompt: "Le RFP du prospect exige conformité GDPR + CCPA + LGPD + PIPEDA. On a GDPR.",
            left: "S'engager sur les quatre", right: 'Se disqualifier' },
    c117: { title: 'Senior Data Scientist',
            prompt: "Marketing veut tracker chaque event de page dans Mixpanel. Le script de tracking fait 240KB.",
            left: 'Réduire aux events qui comptent', right: 'Tout tracker, on triera après' },
    c118: { title: 'Product Designer',
            prompt: 'Brand veut un refresh complet. Logo, palette, typo. Six mois de boulot.',
            left: 'Porter le projet', right: 'Pousser back, focus produit' },
    c119: { title: 'CEO',
            prompt: "Je veux racheter ToolCo. 2k clients, 4M$ d'ARR, pas de croissance. Deal à 20M$.",
            left: 'Lancer la due diligence', right: 'Passer son tour' },
    c120: { title: 'Recruteuse Tech',
            prompt: "Trois de nos PMs se sont fait débaucher sur LinkedIn cette semaine. Trois concurrents différents.",
            left: 'Enquêter sur la culture', right: 'Attendre que ça passe' },
    c121: { title: 'CRO',
            prompt: 'Je veux chaque PM en call sales chaque semaine. Obligatoire.',
            left: 'Essayer', right: 'Bi-mensuel, opt-in' },
    c122: { title: 'Ingénieur Senior',
            prompt: "Notre site docs a 60% de bounce. Tu veux que je passe un sprint à le réécrire ?",
            left: 'Approuver le sprint', right: 'Recruter un tech writer' },
    c123: { title: 'Procurement',
            prompt: '"On veut notre logo HORS de votre homepage. Raisons de compliance."',
            left: 'Retirer ce soir', right: 'Pousser back, atout sales' },
    c124: { title: 'Data Scientist',
            prompt: "Je veux publier un papier sur notre modèle de churn. Co-auteur avec des académiques.",
            left: 'Approuver', right: 'Rester tête baissée' },
    c125: { title: 'Stagiaire de retour',
            prompt: '"Je publie un post Medium sur mon stage. Tu veux le relire ?"',
            left: 'Lire attentivement', right: 'Lui faire confiance' },
    c126: { title: 'Chief of Staff',
            prompt: "Le CEO veut que tu rédiges sa note au board. Il relira demain.",
            left: 'Le prendre', right: 'Décliner poliment' },
    c127: { title: 'UX Researcher',
            prompt: "Je veux interviewer vos pires clients. Ceux qui sont partis énervés.",
            left: 'Approuver le budget', right: 'Rester sur les users actuels' },
    c128: { title: 'Frontend Lead',
            prompt: "On a un bundle JS de 4MB. Sales dit que le produit semble \"lent\".",
            left: 'Lancer un sprint perf', right: 'Faire avec' },
    c129: { title: 'AE Enterprise',
            prompt: "Le client veut un channel Slack privé partagé avec l'équipe ingé.",
            left: 'Ouvrir le channel', right: 'Utiliser Intercom' },
    c130: { title: 'CFO',
            prompt: "Nos coûts cloud explosent au Black Friday. Reserved instances ou autoscale ?",
            left: 'Capacité réservée', right: 'Autoscale, on encaisse' },
    c131: { title: 'Ingénieure Staff',
            prompt: "J'ai réécrit le rate-limiter un samedi. PR ouverte.",
            left: 'Reviewer et merger', right: 'Pas normaliser le boulot le week-end' },
    c132: { title: 'Designer Senior',
            prompt: "Je fais le talk WWDC sur l'accessibilité. Congé ?",
            left: 'Approuver, plein soutien', right: "Plutôt un événement plus petit" },
    c133: { title: 'Head of Talent',
            prompt: "On a une offre PM senior dehors. Il veut renégocier le cliff de vesting.",
            left: 'Renégocier', right: 'Tenir la ligne' },
    c134: { title: 'Engineering Manager',
            prompt: "Je veux passer des reviews de perf trimestrielles à mensuelles. La calibration devient plus dure.",
            left: 'Essayer', right: 'Rester en trimestriel' },
    c135: { title: 'Legal',
            prompt: "Un ingé basé en Russie a touché à nos données via notre sous-traitant.",
            left: 'Enquêter immédiatement', right: 'Couper le sous-traitant' },
    c136: { title: 'CTO chez TenantCo',
            prompt: '"On veut un déploiement private cloud. Air-gapped. On paye 5x."',
            left: "Construire l'offre", right: "Passer, c'est pas notre modèle" },
    c137: { title: 'Account Executive',
            prompt: "J'ai fait un deck disant qu'on est \"AI-first\". On ne l'est pas. Sales l'utilise.",
            left: 'Corriger maintenant', right: 'Laisser filer' },
    c138: { title: 'Product Designer',
            prompt: "L'ingé a supprimé ma config de design tokens dans un refacto. Trois semaines de perdues.",
            left: 'Postmortem complet', right: 'Avancer, restaurer depuis git' },
    c139: { title: 'CEO',
            prompt: "J'ai dit à Bloomberg qu'on livrerait la feature IA d'ici fin d'année. On est en octobre.",
            left: 'Soulever des montagnes', right: 'Faire marche arrière' },
    c140: { title: 'VP Produit',
            prompt: "Je prends un congé sabbatique. Tu veux être VP par intérim trois mois ?",
            left: 'Oui', right: 'Non' },
    f_in_house: { title: 'CTO',
            prompt: "Six mois après. On est en retard sur le build interne. La facture AWS n'a pas baissé.",
            left: 'Tirer la prise', right: 'Continuer' },
    f_apple_reject: { title: 'Mobile Lead',
            prompt: "Apple a accepté la resoumission. Google a rejeté le même jour.",
            left: 'Négocier avec Google', right: 'Livrer Apple-only' },
    f_design_partner: { title: 'Power User',
            prompt: '"Le design partner exige maintenant un siège sur la roadmap."',
            left: 'Lui donner le siège', right: 'Décliner poliment' },
    f_pen_test: { title: 'Ingénieur Sécurité',
            prompt: "On a patché les RCE. Le chercheur a publié quand même.",
            left: 'Coordonner la divulgation', right: 'Attaquer pour rupture' },
    f_brand_refresh: { title: 'Product Designer',
            prompt: "Le refresh brand est livré. Twitter s'est moqué du nouveau logo.",
            left: 'Le défendre publiquement', right: 'Itérer en v1.5' },
    f_acquisition: { title: 'CEO',
            prompt: "Le CEO de ToolCo veut un siège au board dans le deal. Les fondateurs sont divisés.",
            left: 'Donner le siège', right: 'Casser le deal' },
    f_perf_sprint: { title: 'Frontend Lead',
            prompt: "Le bundle est à 1.2MB. Certaines features sont cassées.",
            left: 'Rollback les features cassées', right: 'Hotfix en avant' },
    f_private_slack: { title: 'AE Enterprise',
            prompt: "Le Slack client-ingé a maintenant six autres PMs en lecture.",
            left: 'Verrouiller', right: 'Laisser grossir' },
    f_data_breach: { title: 'Legal',
            prompt: "Le forensic dit que les données d'un client ont été consultées. Ils demandent maintenant.",
            left: 'Divulguer ce soir', right: 'Attendre legal' },
    f_acting_vp: { title: 'VP Produit',
            prompt: "Karen est partie. L'équipe teste les limites.",
            left: 'Mettre la barre haut', right: 'Gagner la confiance lentement' },
  },
};

export default locale;
